function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconTrafficSignExitNar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "traffic_x5F_sign_x5F_exit_x5F_nar_1_",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: "96px",
    height: "96px",
    viewBox: "0 0 96 96",
    style: {
      enableBackground: "new 0 0 96 96"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "traffic_x5F_sign_x5F_exit_x5F_nar"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#0F7742"
    },
    d: "M6,81c-1.654,0-3-1.346-3-3V18c0-1.654,1.346-3,3-3h84c1.654,0,3,1.346,3,3v60c0,1.654-1.346,3-3,3 H6z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M90,16c1.103,0,2,0.897,2,2v60c0,1.103-0.897,2-2,2H6c-1.103,0-2-0.897-2-2V18c0-1.103,0.897-2,2-2 H90 M90,14H6c-2.209,0-4,1.791-4,4v60c0,2.209,1.791,4,4,4h84c2.209,0,4-1.791,4-4V18C94,15.791,92.209,14,90,14L90,14z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#0F7742"
    },
    d: "M6,80c-1.103,0-2-0.897-2-2V18c0-1.103,0.897-2,2-2h84c1.103,0,2,0.897,2,2v60c0,1.103-0.897,2-2,2 H6z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M24.41,23h8.62v2.24h-6.16v3.78h5.68v2.08h-5.68v4.16h6.16v1.98h-8.62V23z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M42.209,30l-4.06-7h2.7l2.96,4.98l2.92-4.98h2.46l-4.06,7l4.18,7.24h-2.68l-3.08-5.22l-3.06,5.22 h-2.46L42.209,30z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M54.65,23h2.46v14.24h-2.46V23z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M62.59,23H73.11v2.24H69.09v12h-2.46v-12h-4.04V23z"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M45.355,48.33c-0.371,0.007-0.742,0.162-1.009,0.428c-0.569,0.569-0.608,1.611,0,2.066 c0.201,0.151,0.412,0.308,0.649,0.376l3.737,1.827l-16.06,16.06l4.949,4.949l16.073-16.073l0.256,0.256l1.951,3.887 c0.069,0.238,0.215,0.457,0.376,0.649c0.519,0.62,1.498,0.57,2.067,0.001c0.267-0.267,0.42-0.639,0.428-1.009L60.853,46 L45.355,48.33z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconTrafficSignExitNar);
export default __webpack_public_path__ + "static/media/icon-traffic_sign_exit_nar.08cc31992d9de1307cc8415da7a96d6a.svg";
export { ForwardRef as ReactComponent };